import { ReportPostUtils } from "../utils";
import { ReportListItem } from "./ListItem";

export const BestProblemDescription = () => {
  return (
    <>
      {ReportPostUtils.bestProblemDescriptionListItems.map((item) => (
        <ReportListItem key={item} label={item} />
      ))}
    </>
  );
};
